import { Box, CheckBox, ModBox, Text } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { useStores } from '../../../data/store'
import { PAYMENT_MODE_SUBTYPES } from '../../../utils/constants'
import { PayLaterContainer } from './PayLaterContainer'
interface PayLaterProps {
  type: string
  isEdit?: boolean
}
const PayLater = ({ type, isEdit }: PayLaterProps) => {
  const { updateAllSelection, isAllPayLaterSelected } = useStores((root) => ({
    updateAllSelection: root.updateAllSelection,
    isAllPayLaterSelected: root.onboarding.isAllPayLaterSelected,
    paylaterSelectedLength: root.payLaterSelectedLength(),
  }))
  const [showAllPayLater, setShowAllPayLater] = useState(isAllPayLaterSelected)
  const onChange = (isChecked: string) => {
    setShowAllPayLater(isChecked === 'true')
    updateAllSelection(isChecked === 'true', PAYMENT_MODE_SUBTYPES.PAYLATER)
  }

  useEffect(() => {
    setShowAllPayLater(isAllPayLaterSelected)
  }, [isAllPayLaterSelected])

  const setIsAllChecked = (isChecked: boolean) => {
    setShowAllPayLater(isChecked)
  }

  return (
    <Box f={1} overflow={'auto'} ph={40} pv={40} minHeight={600}>
      <Text
        title={'Select ‘Pay Later’ options to provide access'}
        color={'BLACK_21'}
        fontSize={18}
        fontFamily={'jiotype-bold'}
      />
      <ModBox
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        marginVertical={24}
        height={32}>
        <CheckBox
          textStyle={'body'}
          onChange={onChange}
          textLabel={'Select all ‘Pay Later’ options'}
          checked={showAllPayLater}
          iconSize={16}
          fontSize={12}
          disabled={!isEdit}
          color={isEdit ? 'BLUE_SHADE_PRIMARY' : 'DARK_GREY'}
        />
      </ModBox>
      <PayLaterContainer isAllChecked={showAllPayLater} isEdit={isEdit} setIsAllChecked={setIsAllChecked} />
    </Box>
  )
}
export { PayLater }
